<div #chartContainer class="w-full h-full relative chart-container-class" [style.min-height]="height"></div>
